import React from 'react';
import { FaStar, FaShieldAlt, FaMobileAlt } from 'react-icons/fa';
import j16Image from '../images/j16-rastreador.png';
import rastreadorUm from '../images/rastreador-um.png';
import rastreadorDois from '../images/rastreador-dois.png';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  const products = [
    {
      id: 1,
      name: 'J16 Rastreador',
      image: j16Image,
      title: 'Tecnologia Avançada',
      description: 'GPS/GLONASS dual mode com bloqueio remoto de motor e alertas em tempo real.',
      badge: 'Mais Vendido',
      features: ['GPS/GLONASS', 'Bloqueio Motor', 'Alertas SMS']
    },
    {
      id: 2,
      name: 'Rastreador Premium',
      image: rastreadorUm,
      title: 'Máxima Precisão',
      description: 'Rastreamento de alta precisão com múltiplas funcionalidades e conectividade 4G.',
      badge: 'Premium',
      features: ['4G LTE', 'Alta Precisão', 'Bateria Longa']
    },
    {
      id: 3,
      name: 'Rastreador Compacto',
      image: rastreadorDois,
      title: 'Design Compacto',
      description: 'Dispositivo discreto e eficiente, ideal para qualquer tipo de veículo.',
      badge: 'Compacto',
      features: ['Design Discreto', 'Fácil Instalação', 'À Prova D\'água']
    }
  ];

  const scrollToDevices = () => {
    const element = document.getElementById('devices');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="featured-products">
      <div className="featured-products-container">
        {/* Header */}
        <div className="featured-products-header">
          <h2 className="featured-products-title">Aparelhos Suportados</h2>
          <p className="featured-products-subtitle">
            Dispositivos GPS compatíveis com nossa plataforma AutoNav
          </p>
          <br/>
          <div className="header-badge">
            <FaStar className="badge-icon" />
            <span>Suportados pela AutoNav</span>
          </div>
        </div>

        {/* Grid de Produtos */}
        <div className="products-grid">
          {products.map((product, index) => (
            <div 
              key={product.id} 
              className={`product-card ${index === 1 ? 'highlighted' : ''}`}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="product-badge">
                <FaStar /> {product.badge}
              </div>

              <div className="product-image-wrapper">
                <div className="product-image-bg"></div>
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="product-image"
                />
              </div>

              <div className="product-content">
                <h3 className="product-title">{product.title}</h3>
                <p className="product-description">{product.description}</p>

                <div className="product-features">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="product-feature">
                      <div className="feature-dot"></div>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <button 
                  className="product-btn"
                  onClick={scrollToDevices}
                >
                  Ver Detalhes
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="featured-cta">
          <div className="cta-icon">
            <FaShieldAlt />
          </div>
          <div className="cta-content">
            <h3>Plataforma AutoNav - Suporte Completo</h3>
            <p>Dispositivos compatíveis com nossa plataforma de monitoramento e rastreamento</p>
          </div>
          <button 
            className="cta-button"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            <FaMobileAlt /> Solicitar Informações
          </button>
        </div>
      </div>

      {/* Background decorativo */}
      <div className="featured-bg-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
    </section>
  );
};

export default FeaturedProducts;

